import DashboardIncidentCategoryBreakdownCard from './DashboardIncidentCategoryBreakdownCard';

export default DashboardIncidentCategoryBreakdownCard;
